<template>
  <div class="mstation-introduce-background">
    <div class="mstation-introduce-banner">
      <div class="mstation-introduce-container">
        <div class="mstation-introduce-banner-title">{{ $t("academic.title") }}</div>
      </div>

      <img class="mstation-introduce-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="mstation-introduce-container">
      <div class="mstation-introduce-content">
        <div class="mstation-introduce-content-info">
          <div
            class="product-markdown-content"
            v-html="markdownHtml"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import academicMd from '!!../../../loaders/md-loader.js!@/common/lang/zh/academic.md'
import academicMdEn from '!!../../../loaders/md-loader.js!@/common/lang/en/academic.md'
import { parseMarkdown } from '@/utils/simpleMarkdown'
import indexImg from '@/assets/solution/index.png'
import booksImg from '@/assets/solution/books.png'
import case1Img from '@/assets/solution/case1.jpg'
import case2Img from '@/assets/solution/case2.jpg'
import case3Img from '@/assets/solution/case3.jpg'
import cooperate1 from '@/assets/home/cooperate_1.png'
import cooperate2 from '@/assets/home/cooperate_2.png'
import cooperate3 from '@/assets/home/cooperate_3.png'
import cooperate4 from '@/assets/home/cooperate_4.png'
import cooperate5 from '@/assets/home/cooperate_5.png'
import cooperate6 from '@/assets/home/cooperate_6.png'
import cooperate7 from '@/assets/home/cooperate_7.png'
import cooperate8 from '@/assets/home/cooperate_8.png'
import cooperate9 from '@/assets/home/cooperate_9.png'
import cooperate10 from '@/assets/home/cooperate_10.png'
import cooperate11 from '@/assets/home/cooperate_11.png'
import cooperate12 from '@/assets/home/cooperate_12.png'

const academicImages = {
  'index.png': indexImg,
  'books.png': booksImg,
  'case1.jpg': case1Img,
  'case2.jpg': case2Img,
  'case3.jpg': case3Img,
  'cooperate_1.png': cooperate1,
  'cooperate_2.png': cooperate2,
  'cooperate_3.png': cooperate3,
  'cooperate_4.png': cooperate4,
  'cooperate_5.png': cooperate5,
  'cooperate_6.png': cooperate6,
  'cooperate_7.png': cooperate7,
  'cooperate_8.png': cooperate8,
  'cooperate_9.png': cooperate9,
  'cooperate_10.png': cooperate10,
  'cooperate_11.png': cooperate11,
  'cooperate_12.png': cooperate12,
}

export default {
  name: 'Academic',
  computed: {
    markdownHtml() {
      const md = this.$i18n.locale === 'en' ? academicMdEn : academicMd
      return parseMarkdown(md, { images: academicImages })
    }
  }
}
</script>

<style scoped>
.mstation-introduce-container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.mstation-introduce-background {
  margin-top: 70px;
}
.mstation-introduce-banner {
  overflow: hidden;
}
.mstation-introduce-banner-title {
  font-size: 24px;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 50px;
  position: absolute;
  margin-top: 60px;
}
.mstation-introduce-banner-img {
  min-width: 100%;
  height: 165px;
}
.mstation-introduce-content {
  margin-top: 30px;
  margin-bottom: 90px;
}
.mstation-introduce-content-info {
  margin-top: 40px;
}
.product-markdown-content {
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
}
.product-markdown-content >>> h2 {
  margin-top: 40px;
  margin-bottom: 16px;
  font-size: 24px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(73, 145, 201, 1);
  line-height: 36px;
}
.product-markdown-content >>> h3 {
  margin-top: 20px;
  margin-bottom: 16px;
  font-size: 30px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(73, 145, 201, 1);
  line-height: 50px;
  text-align: center;
}
.product-markdown-content >>> h4 {
  margin-top: 24px;
  margin-bottom: 12px;
  font-size: 18px;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 600;
  color: rgba(73, 145, 201, 1);
  line-height: 28px;
}
.product-markdown-content >>> p {
  margin-bottom: 16px;
}
.product-markdown-content >>> a {
  color: rgba(73, 145, 201, 1);
  text-decoration: none;
  cursor: pointer;
}
.product-markdown-content >>> a:hover {
  text-decoration: underline;
}
.product-markdown-content >>> .md-image-row {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin: 24px 0;
}
.product-markdown-content >>> .md-image {
  display: block;
  max-width: 100%;
  height: auto;
  margin: 24px auto;
}
.product-markdown-content >>> .md-image-row-1 {
  flex-direction: column;
}
.product-markdown-content >>> .md-image-row-1 .md-image {
  width: 100%;
  margin: 0;
}
.product-markdown-content >>> .md-image-row-4 {
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  margin: 28px 0;
}
.product-markdown-content >>> .md-image-row-4 .md-image {
  flex: 1 1 0;
  min-width: 0;
  max-width: calc((100% - 72px) / 4);
  max-height: 70px;
  width: auto;
  margin: 0;
  object-fit: contain;
}
.product-markdown-content >>> ol {
  padding-left: 20px;
  margin-bottom: 16px;
}
.product-markdown-content >>> li {
  margin-bottom: 8px;
}
@media screen and (max-width: 768px) {
  .product-markdown-content >>> .md-image-row-4 {
    flex-wrap: wrap;
  }
  .product-markdown-content >>> .md-image-row-4 .md-image {
    flex: 0 0 calc(50% - 8px);
    max-width: calc(50% - 8px);
  }
}
@media screen and (max-width: 482px) {
  .mstation-introduce-container {
    max-width: 100%;
  }
}
@media screen and (min-width: 482px) and (max-width: 768px) {
  .mstation-introduce-container {
    max-width: 450px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1100px) {
  .mstation-introduce-container {
    max-width: 736px;
  }
}
@media screen and (min-width: 1100px) and (max-width: 1444px) {
  .mstation-introduce-container {
    max-width: 1068px;
  }
}
@media screen and (min-width: 1444px) {
  .mstation-introduce-container {
    max-width: 1068px;
  }
}
</style>
